function initInformation(root) {
  const toc = root.querySelector('[data-info-toc]');
  if (!toc || toc.dataset.ready) return;
  toc.dataset.ready = 'true';
  const headings = [...root.querySelectorAll('.oracura-info__content h2')].filter(h => h.textContent.trim());
  if (headings.length < 2) return;
  headings.slice(0, 8).forEach((heading, i) => {
    if (!heading.id) heading.id = `information-heading-${i}`;
    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent.trim();
    toc.append(a);
  });
  toc.hidden = false;
}
document.querySelectorAll('.oracura-info').forEach(initInformation);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.oracura-info').forEach(initInformation));

// How-to videos: the link over each thumbnail becomes the YouTube player in
// place, so nothing from YouTube loads until a video is asked for. Without
// this script the link still opens the video on YouTube.
document.addEventListener('click', event => {
  const link = event.target.closest('[data-info-youtube]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.button > 0) return;
  event.preventDefault();
  const frame = document.createElement('iframe');
  frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(link.dataset.infoYoutube)}?autoplay=1&rel=0&playsinline=1`;
  frame.title = link.getAttribute('aria-label') || '';
  frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  frame.allowFullscreen = true;
  link.hidden = true;
  link.after(frame);
  frame.focus();
});

// ---------------------------------------------------------------------------
// App forms (Acerill form builder): a check before the app's own submit.
// The app accepts a phone number of any length, its own "Select" placeholders
// as answers, dates in the future and negative numbers, and marks nothing on
// the page when a field is wrong. This runs in the capture phase on window,
// before the app hears the click: when a visible field breaks a rule below,
// the click stops here, each field says what is wrong under it, and the page
// scrolls to the first one. When everything passes, the click goes on to the
// app untouched, so its own checks (email, files) and its submit still run.
// Values are only read, never rewritten, so the app submits what it holds.
// ---------------------------------------------------------------------------
const CF_SUBMIT = '.acerill-custom-form .submit-button-wrapper button, .acerill-custom-form .submit-button-wrapper .cf-btn';

function cfLabel(field) {
  const group = field.closest('.form-group');
  if (!group) return '';
  const label = (field.id && group.querySelector(`label[for="${CSS.escape(field.id)}"]`)) || group.querySelector('label.control-label');
  return label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
}

function cfShown(field) {
  if (field.disabled || field.type === 'hidden' || field.type === 'file') return false;
  const wrapper = field.closest('.form-field-wrapper');
  if (wrapper && (getComputedStyle(wrapper).visibility === 'hidden' || wrapper.getClientRects().length === 0)) return false;
  return field.getClientRects().length > 0;
}

function cfToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Indian mobile: 10 digits starting 6-9, once spaces, dashes, brackets and a
// leading +91, 91 or 0 come off.
function cfMobileOk(value) {
  let v = value.replace(/[\s\-().]/g, '');
  if (v.startsWith('+91')) v = v.slice(3);
  else if (/^91\d{10}$/.test(v)) v = v.slice(2);
  else if (/^0\d{10}$/.test(v)) v = v.slice(1);
  return /^[6-9]\d{9}$/.test(v);
}

function cfProblem(field) {
  if (field.type === 'checkbox' || field.type === 'radio') return '';
  const required = /\*$/.test(cfLabel(field));
  const value = (field.value || '').trim();
  if (field.tagName === 'SELECT') {
    const option = field.options[field.selectedIndex];
    const unanswered = !option || option.value === '' || /^(--\s*)?select\b/i.test(option.text.trim());
    return required && unanswered ? 'Choose an option.' : '';
  }
  if (!value) {
    if (!required) return '';
    return field.type === 'tel' ? 'Enter your 10-digit mobile number.' : 'This field is required.';
  }
  if (field.type === 'tel' && !cfMobileOk(value)) return 'Enter a 10-digit mobile number starting with 6, 7, 8 or 9.';
  if (field.type === 'date' && value > cfToday()) return 'This date cannot be in the future.';
  if (field.type === 'number' && Number(value) < 0) return 'Enter 0 or more.';
  return '';
}

function cfMark(field, message) {
  const group = field.closest('.form-group') || field.parentElement;
  let note = group.querySelector(':scope > .oracura-cf-error');
  if (!message) {
    field.removeAttribute('data-oracura-invalid');
    field.removeAttribute('aria-invalid');
    if (note) note.remove();
    return;
  }
  field.setAttribute('data-oracura-invalid', '');
  field.setAttribute('aria-invalid', 'true');
  if (!note) {
    note = document.createElement('p');
    note.className = 'oracura-cf-error';
    note.id = `${field.id || 'cf'}-oracura-error`;
    group.append(note);
  }
  note.textContent = message;
  const described = (field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
  if (!described.includes(note.id)) field.setAttribute('aria-describedby', [...described, note.id].join(' '));
}

// Brings a field into view below the sticky header, then focuses it.
function cfReveal(field) {
  const rect = field.getBoundingClientRect();
  if (rect.top < 140 || rect.bottom > window.innerHeight - 24) field.scrollIntoView({ block: 'center' });
  try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
}

// Hints the app leaves off: a number keypad and autofill for phones, autofill
// for email and name, and the required state for screen readers.
function cfEnhance(form) {
  form.querySelectorAll('input, select, textarea').forEach(field => {
    if (field.dataset.oracuraCf || field.type === 'hidden' || field.type === 'file') return;
    const label = cfLabel(field);
    if (!label) return;
    field.dataset.oracuraCf = '1';
    if (/\*$/.test(label)) field.setAttribute('aria-required', 'true');
    if (field.getAttribute('autocomplete')) return;
    if (field.type === 'tel') {
      field.setAttribute('inputmode', 'numeric');
      field.setAttribute('autocomplete', 'tel-national');
    } else if (field.type === 'email') {
      field.setAttribute('autocomplete', 'email');
    } else if (field.type === 'text' && /^(full )?name\b/i.test(label)) {
      field.setAttribute('autocomplete', 'name');
    }
  });
}

window.addEventListener('click', event => {
  const button = event.target.closest && event.target.closest(CF_SUBMIT);
  if (!button) return;
  const form = button.closest('.acerill-custom-form');
  cfEnhance(form);
  let first = null;
  [...form.querySelectorAll('input, select, textarea')].filter(cfShown).forEach(field => {
    const message = cfProblem(field);
    cfMark(field, message);
    if (message && !first) first = field;
  });
  if (first) {
    event.preventDefault();
    event.stopImmediatePropagation();
    cfReveal(first);
    return;
  }
  // The app's own checks run next. When they fail it marks the groups
  // .has-error but leaves the page where it is, often far below them.
  setTimeout(() => {
    const failed = [...form.querySelectorAll('.has-error')].find(group => group.getClientRects().length);
    const field = failed && failed.querySelector('input:not([type=hidden]):not([type=file]), select, textarea');
    if (field) cfReveal(field);
  }, 150);
}, true);

// A field drops its message as soon as it is put right.
['input', 'change'].forEach(type => document.addEventListener(type, event => {
  const field = event.target;
  if (!field.matches || !field.matches('[data-oracura-invalid]')) return;
  if (!cfProblem(field)) cfMark(field, '');
}, true));

// Each form gets its hints once the app has drawn it.
const cfObserver = new MutationObserver(records => {
  records.forEach(record => {
    const form = record.target.closest && record.target.closest('.acerill-custom-form');
    if (form) cfEnhance(form);
  });
});
document.querySelectorAll('.acerill-custom-form').forEach(form => {
  cfEnhance(form);
  cfObserver.observe(form, { childList: true, subtree: true });
});
